// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import configs from '../configs';
import { IntegrationLayout, CredentialsSetup, ExternalLinkA } from '../_shared';

class Blitz extends Component {
  componentDidMount() {
    this.props.store.integrations.Blitz.getConfigs();
  }

  render() {
    return (
      <IntegrationLayout config={configs.Blitz}>
        <CredentialsSetup
          partnerKey="Blitz"
          steps={[
            <>Make an account with Blitz <ExternalLinkA href="https://www.blitzleadmanager.com/login/Registration.aspx?partner=Movology">here</ExternalLinkA> if you have not done so already.</>,
            'Navigate to the "My Profile" screen within Blitz Lead Manager.',
            'Copy and paste the API URL, API ID, and Transaction ID below then click Update.',
            'Future captures will be added as leads daily within Blitz Lead Manager.',
          ]}
          fields={[
            { name: 'apiUrl', label: 'API URL', placeholder: 'https://www.blitzleadmanager.com/companya/ws/ws.asmx' },
            { name: 'apiId', label: 'API ID' },
            { name: 'transactionId', label: 'Transaction ID' },
          ]}
        />
      </IntegrationLayout>
    );
  }
}

export default inject('store')(observer(Blitz));
